import { Client } from "@domain/models/Client";
import { MapClient } from "@domain/models/MapClient";
import { MarkerIconTypes } from "@domain/models/MarkerIcon";
import userStore from "@data/stores/user";

export const markersHelper = {
  getMarkerIcons,
  getSpecieIcon,
  getMapLegends,
};

function getMarkerIcons(client: MapClient) {
  const { user } = userStore.getState();

  if (client.specialIcon) {
    return client.iconUrl;
  }

  const hoje = new Date();

  const dia = client.birthDate.slice(0, 2);
  const month = Number(client.birthDate.slice(3, 5));
  const ano = Number(client.birthDate.slice(-4)) + 65;

  let alertMonth;
  if (month - 6 < 0) {
    alertMonth = 12 + (month - 6);
  } else {
    alertMonth = month - 6;
  }

  const dateAlert = new Date(`${alertMonth}-20-${ano}`);
  const dateBirthday = new Date(`${month}-${dia}-${ano}`);

  if (
    user?.markerIcons &&
    hoje.getTime() >= dateAlert.getTime() &&
    hoje.getTime() <= dateBirthday.getTime()
  ) {
    const icon = user.markerIcons.find((x) => x.type === "BIRTHDAY");

    return icon ? icon.url : client.iconUrl;
  }

  return client.iconUrl;
}

function getSpecieIcon(specie: Client["specie"]) {
  const { user } = userStore.getState();

  if (user?.markerIcons) {
    const index = user.markerIcons.findIndex((x) => x.type === specie);

    if (index !== -1) {
      return user.markerIcons[index].url;
    }
  }

  return null;
}

function getMapLegends(exceptionsTypes: MarkerIconTypes[] = []) {
  const { user } = userStore.getState();

  if (user?.markerIcons) {
    return user.markerIcons.filter((x) => !exceptionsTypes.includes(x.type));
  }

  return [];
}
